import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppShell } from '@/components/layout';
import { SessionsPage, UploadPage, ReviewPage, KnowledgeBasePage, LoginPage } from '@/pages';
import { ProtectedRoute } from '@/components/common';
import { BatchesPage, BatchWorkbench } from '@/features/admin/import-review';

// Build-time feature flag: Import Review Workbench (Task 5+).
// Enable locally with: VITE_IMPORT_REVIEW=true npm run dev
const IMPORT_REVIEW_ENABLED = import.meta.env.VITE_IMPORT_REVIEW === 'true';

export const router = createBrowserRouter([
  // Login page — outside AppShell, no nav
  {
    path: '/login',
    element: <LoginPage />,
  },

  // Protected routes — behind auth
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: '/',
        element: <AppShell />,
        children: [
          {
            index: true,
            element: <Navigate to="/sessions" replace />,
          },
          {
            path: 'sessions',
            element: <SessionsPage />,
          },
          {
            path: 'sessions/:id/review',
            element: <ReviewPage />,
          },
          {
            path: 'upload',
            element: <UploadPage />,
          },
          {
            path: 'knowledge-base',
            element: <KnowledgeBasePage />,
          },
          // Import Review Workbench — gated by VITE_IMPORT_REVIEW flag
          ...(IMPORT_REVIEW_ENABLED
            ? [
                {
                  path: 'admin/import-review',
                  element: <BatchesPage />,
                },
                {
                  path: 'admin/import-review/:batchId',
                  element: <BatchWorkbench />,
                },
              ]
            : []),
        ],
      },
    ],
  },
]);
